import { render, staticRenderFns } from "./TerminationApply.vue?vue&type=template&id=13f2adf7&scoped=true&"
import script from "./TerminationApply.vue?vue&type=script&lang=js&"
export * from "./TerminationApply.vue?vue&type=script&lang=js&"
import style0 from "./TerminationApply.vue?vue&type=style&index=0&id=13f2adf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f2adf7",
  null
  
)

export default component.exports